export default __webpack_public_path__ + "static/media/warningZero.37a67aa9.svg";